var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('tab-nav', {
          staticClass: "iq-edit-profile d-flex",
          attrs: {
            "pills": true
          }
        }, [_c('tab-nav-items', {
          staticClass: "col-md-3 p-0",
          attrs: {
            "active": true,
            "href": "#equipment-category",
            "title": "Equipment Category"
          },
          on: {
            "click": function click($event) {
              _vm.tabSelected = 'equipment-category';
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-3 p-0",
          attrs: {
            "active": false,
            "href": "#master-equipment",
            "title": "Master Equipment"
          },
          on: {
            "click": function click($event) {
              _vm.tabSelected = 'master-equipment';
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-3 p-0",
          attrs: {
            "active": false,
            "href": "#jobClass",
            "title": "Job Class"
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-3 p-0",
          attrs: {
            "active": false,
            "href": "#job",
            "title": "Job Type / Index"
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "pills-tabContent-2"
    }
  }, [_c('tab-content-item', {
    attrs: {
      "active": true,
      "id": "equipment-category"
    }
  }, [_vm.tabSelected == 'equipment-category' ? [_c('MasterEquipmentCategory')] : _vm._e()], 2), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "master-equipment"
    }
  }, [_vm.tabSelected == 'master-equipment' ? [_c('MasterEquipment')] : _vm._e()], 2), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "jobClass"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("Job Class Data")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex mb-3"
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "id": "fleet_name",
            "type": "text",
            "placeholder": "Search..."
          },
          on: {
            "input": _vm.debouncedJobClassSearch,
            "keypress": function keypress($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.searchJobClass.apply(null, arguments);
            }
          },
          model: {
            value: _vm.jobClass.params.search,
            callback: function callback($$v) {
              _vm.$set(_vm.jobClass.params, "search", $$v);
            },
            expression: "jobClass.params.search"
          }
        })], 1), _c('b-row', [_c('b-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table mb-0 table-striped table-hover"
        }, [_c('thead', {
          staticClass: "thead-dark text-center"
        }, [_c('tr', [_c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("No.")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v(" Job Class Code ")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("Job Class")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("Description")]), _c('th', {
          staticClass: "text-truncate text-center"
        }, [_vm._v("Status")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("Action")])])]), _vm.jobClass.data && _vm.jobClass.data.length > 0 ? _c('tbody', _vm._l(_vm.jobClass.data, function (each, i) {
          return _c('tr', {
            key: i
          }, [_c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(_vm.getOverallIndex(i, 'jobClass')) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(each.jobClassCode) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(each.jobClass))]), _c('td', {
            staticClass: "text-truncate"
          }, [each.description ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(each.description)
            }
          }) : _c('span', [_vm._v("-")])]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_c('b-badge', {
            attrs: {
              "variant": each.active ? 'success' : 'danger'
            }
          }, [_vm._v(" " + _vm._s(each.active ? 'Active' : 'Inactive') + " ")])], 1), _c('td', {
            staticClass: "text-truncate"
          }, [_c('span', {
            staticClass: "text-info mr-1 cursor-pointer mr-2",
            on: {
              "click": function click($event) {
                return _vm.initFormJobClass(each);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          })]), _c('span', {
            staticClass: "text-danger cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.onDeleteJobClass(each);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          })])])]);
        }), 0) : _c('tbody', [_c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "8"
          }
        }, [_vm._v("No Data")])])])])])]), _vm.jobClass.data && _vm.jobClass.data.length > 0 ? _c('b-col', {
          staticClass: "mt-4"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.jobClass.meta.total,
            "per-page": _vm.jobClass.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.getJobClassList
          },
          model: {
            value: _vm.jobClass.meta.currentPage,
            callback: function callback($$v) {
              _vm.$set(_vm.jobClass.meta, "currentPage", $$v);
            },
            expression: "jobClass.meta.currentPage"
          }
        })], 1) : _vm._e()], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('iq-card', {
    class: {
      'border border-danger shadow-lg': _vm.jobClass.editMode
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v(" " + _vm._s(_vm.jobClass.editMode ? 'Edit' : 'Add') + " Job Class ")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.saveJobClass();
            },
            "reset": function reset($event) {
              $event.preventDefault();
              return _vm.initFormJobClass();
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Job Class Code",
            "label-for": "project_location"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "Power Name",
            "type": "text",
            "placeholder": "Job Class Code",
            "maxlength": "30"
          },
          model: {
            value: _vm.jobClass.form.jobClassCode,
            callback: function callback($$v) {
              _vm.$set(_vm.jobClass.form, "jobClassCode", $$v);
            },
            expression: "jobClass.form.jobClassCode"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Job Class",
            "label-for": "project_location"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "Power Name",
            "type": "text",
            "placeholder": "Job Class",
            "maxlength": "30"
          },
          model: {
            value: _vm.jobClass.form.jobClass,
            callback: function callback($$v) {
              _vm.$set(_vm.jobClass.form, "jobClass", $$v);
            },
            expression: "jobClass.form.jobClass"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "Description",
            "label": "Description"
          }
        }, [_c('tinymce', {
          attrs: {
            "id": "d1"
          },
          model: {
            value: _vm.jobClass.form.description,
            callback: function callback($$v) {
              _vm.$set(_vm.jobClass.form, "description", $$v);
            },
            expression: "jobClass.form.description"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Status",
            "label-for": "technical_module"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.jobClass.form.active,
            callback: function callback($$v) {
              _vm.$set(_vm.jobClass.form, "active", $$v);
            },
            expression: "jobClass.form.active"
          }
        }, [_vm.jobType.form.active === false ? [_vm._v(" Inactive ")] : [_vm._v("Active")]], 2)], 1), _c('hr'), _c('b-form-group', {
          staticClass: "text-right"
        }, [_c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.jobClass.editMode ? 'Save' : 'Add'))])]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "reset",
            "variant": "danger"
          }
        }, [_vm._v(" Cancel ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "job"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("Job Type / Job Index Data")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex mb-3"
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "id": "fleet_name",
            "type": "text",
            "placeholder": "Search..."
          },
          on: {
            "input": _vm.debouncedJobTypeSearch,
            "keypress": function keypress($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.searchJobType.apply(null, arguments);
            }
          },
          model: {
            value: _vm.jobType.params.search,
            callback: function callback($$v) {
              _vm.$set(_vm.jobType.params, "search", $$v);
            },
            expression: "jobType.params.search"
          }
        })], 1), _c('b-row', [_c('b-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table mb-0 table-striped table-hover"
        }, [_c('thead', {
          staticClass: "thead-dark text-center"
        }, [_c('tr', [_c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("No.")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v(" Job Type Code ")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v(" Job Type / Job Index ")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("Description")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("Status")]), _c('th', {
          staticClass: "text-truncate text-left"
        }, [_vm._v("Action")])])]), _vm.jobType.data && _vm.jobType.data.length > 0 ? _c('tbody', _vm._l(_vm.jobType.data, function (each, i) {
          return _c('tr', {
            key: i
          }, [_c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(_vm.getOverallIndex(i, 'jobType')) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(each.jobTypeCode) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(each.jobTypeIndex) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(each.description) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_c('b-badge', {
            attrs: {
              "variant": each.active ? 'success' : 'danger'
            }
          }, [_vm._v(" " + _vm._s(each.active ? 'Active' : 'Inactive') + " ")])], 1), _c('td', {
            staticClass: "text-truncate"
          }, [_c('span', {
            staticClass: "text-info mr-1 cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.initFormJobType(each);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          })]), _c('span', {
            staticClass: "text-danger cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.onDeleteJobType(each);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          })])])]);
        }), 0) : _c('tbody', [_c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "8"
          }
        }, [_vm._v("No Data")])])])])])]), _vm.jobType.data && _vm.jobType.data.length > 0 ? _c('b-col', {
          staticClass: "mt-4"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.jobType.meta.total,
            "per-page": _vm.jobType.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.getJobTypeList
          },
          model: {
            value: _vm.jobType.meta.currentPage,
            callback: function callback($$v) {
              _vm.$set(_vm.jobType.meta, "currentPage", $$v);
            },
            expression: "jobType.meta.currentPage"
          }
        })], 1) : _vm._e()], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('iq-card', {
    class: {
      'border border-danger shadow-lg': _vm.jobType.editMode
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v(" " + _vm._s(_vm.jobType.editMode ? 'Edit' : 'Add') + " Job Type / Job Index ")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.saveJobType();
            },
            "reset": function reset($event) {
              $event.preventDefault();
              return _vm.initFormJobType();
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Job Type Code",
            "label-for": "project_location"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "Power Name",
            "type": "text",
            "placeholder": "Job Type Code",
            "maxlength": "30"
          },
          model: {
            value: _vm.jobType.form.jobTypeCode,
            callback: function callback($$v) {
              _vm.$set(_vm.jobType.form, "jobTypeCode", $$v);
            },
            expression: "jobType.form.jobTypeCode"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Job Type / Job Index",
            "label-for": "project_location"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "Power Name",
            "type": "text",
            "placeholder": "Job Type",
            "maxlength": "30"
          },
          model: {
            value: _vm.jobType.form.jobTypeIndex,
            callback: function callback($$v) {
              _vm.$set(_vm.jobType.form, "jobTypeIndex", $$v);
            },
            expression: "jobType.form.jobTypeIndex"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-for": "Description",
            "label": "Description"
          }
        }, [_c('b-form-textarea', {
          attrs: {
            "id": "textarea",
            "placeholder": "Enter something...",
            "rows": "3",
            "max-rows": "6"
          },
          model: {
            value: _vm.jobType.form.description,
            callback: function callback($$v) {
              _vm.$set(_vm.jobType.form, "description", $$v);
            },
            expression: "jobType.form.description"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Status",
            "label-for": "technical_module"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.jobType.form.active,
            callback: function callback($$v) {
              _vm.$set(_vm.jobType.form, "active", $$v);
            },
            expression: "jobType.form.active"
          }
        }, [_vm.jobType.form.status === false ? [_vm._v(" Inactive ")] : [_vm._v("Active")]], 2)], 1), _c('hr'), _c('b-form-group', {
          staticClass: "text-right"
        }, [_c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.jobType.editMode ? 'Save' : 'Add'))])]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "reset",
            "variant": "danger"
          }
        }, [_vm._v(" Cancel ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }